import { createContext } from 'react'

const DefaultLayoutContext = createContext()

export default DefaultLayoutContext
